import React from 'react';
import { HeroSection } from './components/HeroSection';
import { MetricsTestimonialsSection } from './components/MetricsTestimonialsSection';
import { PainSection } from './components/PainSection';
import { TransitionHookSection } from './components/TransitionHookSection';
import { ProductIntroSection } from './components/ProductIntroSection';
import { ModulesSection } from './components/ModulesSection';
import { ModuleInclusionsSection } from './components/ModuleInclusionsSection';
import { BonusesSection } from './components/BonusesSection';
import { BonusValueSection } from './components/BonusValueSection';
import { UrgencySection } from './components/UrgencySection';
import { PriceSection } from './components/PriceSection';
import { ExtendedTestimonialsSection } from './components/ExtendedTestimonialsSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FaqSection } from './components/FaqSection';
import { ComparisonSection } from './components/ComparisonSection';
import { FinalCtaSection } from './components/FinalCtaSection';
import { FooterSection } from './components/FooterSection';
import { SocialProofPopup } from './components/SocialProofPopup';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <div className="font-sans text-biosync-text bg-white min-h-screen" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <SocialProofPopup data-id="element-2" />
      <HeroSection data-id="element-3" />
      <MetricsTestimonialsSection data-id="element-4" />
      <PainSection data-id="element-5" />
      <TransitionHookSection data-id="element-6" />
      <ProductIntroSection data-id="element-7" />
      <ModulesSection data-id="element-8" />
      <ModuleInclusionsSection data-id="element-9" />
      <BonusesSection data-id="element-10" />
      <BonusValueSection data-id="element-11" />
      <UrgencySection data-id="element-12" />
      <PriceSection data-id="element-13" />
      <ExtendedTestimonialsSection data-id="element-14" />
      <GuaranteeSection data-id="element-15" />
      <FaqSection data-id="element-16" />
      <ComparisonSection data-id="element-17" />
      <FinalCtaSection data-id="element-18" />
      <FooterSection data-id="element-19" />
    </div>;
}